import React from 'react';

const Footer = () => {
    return (
        <div className="footer">
            <p>
                Creado por: <span>Jesús Hernández</span>
            </p>
        </div>
    );
};

export default Footer;
